module.exports = __webpack_public_path__ + "img/product43_img02.93366a78.png";